import { createRouter, createWebHashHistory } from "vue-router"

const routes = [
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: "/index",
    name: "Index",
    component: () => import("@/view/indexPage.vue"),
    meta: {
      title: "title.index",
    }
  },
  {
    path: "/about",
    name: "About",
    component: () => import("@/view/aboutPage.vue"),
    meta: {
      title: "title.about",
    }
  },
  {
    path: "/cooperation",
    name: "Compare",
    component: () => import("@/view/comparePage.vue"),
    meta: {
      title: "title.cooperation",
    }
  },
  {
    path: "/introduce",
    name: "Introduce",
    component: () => import("@/view/introducePage.vue"),
    meta: {
      title: "title.introduce",
    }
  },
  {
    path: "/NTN",
    name: "Ntn",
    component: () => import("@/view/ntnPage.vue"),
    meta: {
      title: "title.ntn",
    }
  },
  {
    path: "/develop",
    name: "Develop",
    component: () => import("@/view/developPage.vue"),
    meta: {
      title: "title.develop",
    }
  },
  {
    path: "/contact",
    name: "Contact",
    component: () => import("@/view/contactPage.vue"),
    meta: {
      title: "title.contact",
    }
  },
  {
    path: "/info",
    name: "Info",
    component: () => import("@/view/infoPage.vue"),
    meta: {
      title: "title.info",
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

export default router
